import { NavLink } from 'react-router';
import { Compass, House, LibraryBig, Search } from 'lucide-react';
import { useActiveProfile } from '@/lib/queries';
import { ProfileAvatar } from '../profile/avatar';
import { cn } from '@/lib/cn';

const ITEMS = [
  { to: '/home', label: 'Home', icon: House },
  { to: '/search', label: 'Search', icon: Search },
  { to: '/discover', label: 'Discover', icon: Compass },
  { to: '/library', label: 'Library', icon: LibraryBig },
];

export function MobileNavigation() {
  const { data } = useActiveProfile();
  return (
    <nav
      aria-label="Mobile"
      className="glass fixed inset-x-0 bottom-0 z-40 border-t border-line/70 pb-[env(safe-area-inset-bottom)] lg:hidden"
    >
      <ul className="mx-auto flex h-16 max-w-xl items-stretch justify-around">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              className={({ isActive }) =>
                cn(
                  'flex h-full flex-col items-center justify-center gap-1 text-[11px] font-medium',
                  isActive ? 'text-pink' : 'text-muted',
                )
              }
            >
              <Icon className="h-5.5 w-5.5" aria-hidden />
              {label}
            </NavLink>
          </li>
        ))}
        <li className="flex-1">
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              cn(
                'flex h-full flex-col items-center justify-center gap-1 text-[11px] font-medium',
                isActive ? 'text-pink' : 'text-muted',
              )
            }
          >
            {data ? (
              <ProfileAvatar
                avatar={data.profile.avatar}
                image={data.profile.avatarUrl}
                size={24}
                className="rounded-md"
              />
            ) : (
              <span className="h-6 w-6 rounded-md bg-card" />
            )}
            Profile
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
